"use client";

import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

import styles from "./free-policy.module.scss";
import services from "@/store/services";
import apis from "@/api";

const FreeTimePolicyModal = (props) => {
  const { isUserVoted, setIsUserVoted } = props;
  const { deviceId } = useSelector((state) => state.nonAuthWatchTime);
  const user = useSelector((state) => state.user.users);

  const [selectedOption, setSelectedOption] = useState("");
  const [customValue, setCustomValue] = useState("");

  const dispatch = useDispatch();

  const handleInterestedVote = async () => {
    try {
      let amount = null;
      if (selectedOption === "custom") {
        amount = parseInt(customValue, 10);
      } else {
        amount = parseInt(selectedOption, 10);
      }

      // if (amount < 49) {
      //   dispatch(services.warningAlert("Entered value is less than 49!"));
      //   return;
      // }

      const payload = {
        type: "interested",
        entityId: user?._id || deviceId,
        amount,
      };

      const res = await apis.addUserVote(payload);
      if (res?.data?.success === 200) {
        setIsUserVoted(true);
      }
    } catch (error) {
      console.error("Error voting:", error);
    }
  };

  return (
    <section className={styles.container}>
      {!isUserVoted ? (
        <>
          <p className={styles.description}>
            We’re exploring a low-cost plan to keep spammers and exploiters out.
            To help us make the right decision, tell us:
          </p>

          <div className={styles.options}>
            <label className={styles.option}>
              <input
                type="radio"
                name="price"
                value="49"
                checked={selectedOption === "49"}
                onChange={() => setSelectedOption("49")}
              />
              ₹49/month — Affordable and works for me 👍
            </label>

            <label className={styles.option}>
              <input
                type="radio"
                name="price"
                value="99"
                checked={selectedOption === "99"}
                onChange={() => setSelectedOption("99")}
              />
              ₹99/month — I’d support a bit more 💪
            </label>

            <label className={styles.option}>
              <input
                type="radio"
                name="price"
                value="custom"
                checked={selectedOption === "custom"}
                onChange={() => setSelectedOption("custom")}
              />
              Custom: ₹
              <input
                type="number"
                min="1"
                placeholder="Enter amount"
                value={customValue}
                onChange={(e) => setCustomValue(e.target.value)}
                className={styles.customInput}
                disabled={selectedOption !== "custom"}
              />
              <span>Number Only</span>
            </label>
          </div>

          <p className={styles.note}>
            Note: This is a one-time vote. Your response will help shape our
            future plans.
          </p>

          <button
            className={`${styles.submitBtn} ${
              !selectedOption || (selectedOption === "custom" && !customValue)
                ? styles.disabled
                : ""
            }`}
            disabled={
              !selectedOption || (selectedOption === "custom" && !customValue)
            }
            onClick={handleInterestedVote}
          >
            Submit Your Interest
          </button>
        </>
      ) : (
        <div className={styles.thankYou}>
          <h2>🎉 Thank you!</h2>
          <p>
            Your vote has been recorded.
            <br /> We’ll keep you posted on what’s coming next.
          </p>
          <button
            className={styles.closeBtnThankyou}
            onClick={() => dispatch(services.toggleFreeTimePolicyModal())}
          >
            Close
          </button>
        </div>
      )}
    </section>
  );
};

export default FreeTimePolicyModal;
